module.exports = __webpack_public_path__ + "static/media/razrabotka-phone.e50d2d80.png";